// ParentsAwarenessProgramAlbum.js

import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Modal,
  Backdrop,
  IconButton,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

// Local image imports
import img1 from "../../assets/images/MotivationalProgram2025/1.jpg";
import img2 from "../../assets/images/MotivationalProgram2025/2.jpg";
import img3 from "../../assets/images/MotivationalProgram2025/3.jpg";
import img4 from "../../assets/images/MotivationalProgram2025/4.jpg";
import img5 from "../../assets/images/MotivationalProgram2025/5.jpg";
import img6 from "../../assets/images/MotivationalProgram2025/6.jpg";
import img7 from "../../assets/images/MotivationalProgram2025/7.jpg";

const imageUrls = [img2, img3, img4, img5, img6, img7];

const ParentsAwarenessProgramAlbum = () => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const handleOpen = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);
  const handleBack = () => navigate(-1);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    initialSlide: currentIndex,
  };

  return (
    <Container>
      <Box sx={{ backgroundColor: "#f9f9f9", p: 3, borderRadius: 2, mb: 5 }}>
        <IconButton onClick={handleBack} sx={{ mb: 3 }}>
          <ArrowBack fontSize="large" />
        </IconButton>
        <Typography textAlign="center" variant="h4" fontWeight="bold" mb={3}>
          🌟 Inspire CareerFest Parents' Awareness Program 2025 🌟
        </Typography>

        <Typography textAlign="justify" variant="body1">
          Inspire CareerFest 2025 along with the 👪 Parents' Awareness Program
          was successfully held yesterday, Sunday, May 18, at 🏢 PAB Function
          Hall, Pernambut.
          <br />
          <br />
          🕊 Over 150 participants—including parents, students, and community
          members—joined us for this purposeful gathering. The event was
          well-received and left a 💖 positive impact on all who attended. 🌟
          <br />
          <br />
          📢 <strong>The Main Highlight</strong>
          <br />
          <br />
          The main highlight of the evening was the 💡 insightful Parents'
          Awareness Session by Moulana Shamsudeen Qasimi, Principal of Jamia
          Darul Ilmi, Chennai. He addressed the 🤝 critical role of parents in
          guiding their children’s career journey, encouraging them to support
          both 📚 educational and Islamic development with wisdom and balance.
          <br />
          <br />
          👍 The audience deeply appreciated the message, and many parents
          expressed how 🕰 timely and beneficial the session was in today’s
          challenging environment. 💐
          <br />
          <br />
          We extend our ❤ heartfelt thanks to everyone who attended, supported,
          and prayed for the success of the program.
          <br />
          <br />— 🌈 <strong>Team TIET</strong>
        </Typography>
      </Box>

      <Grid container spacing={2} justifyContent="center">
        {imageUrls.map((src, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <img
              src={src}
              alt={`Event ${index + 1}`}
              onClick={() => handleOpen(index)}
              style={{
                width: "100%",
                height: "300px",
                objectFit: "cover",
                cursor: "pointer",
                borderRadius: "10px",
              }}
            />
          </Grid>
        ))}
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100vw",
            bgcolor: "rgba(0, 0, 0, 0.9)",
          }}
        >
          <Box sx={{ width: "90vw", height: "90vh" }}>
            <Slider {...settings}>
              {imageUrls.map((src, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "90vh",
                    width: "90vw",
                  }}
                >
                  <img
                    src={src}
                    alt={`Event ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default ParentsAwarenessProgramAlbum;
